<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1COwIBZ/tc-custom/9781467461450.jpg?1731056130716" alt="This image is the cover for the book Migration and the Making of Global Christianity"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Migration and the Making of Global Christianity
      </h1>
      <p class="bookDescription body article font2">
        <p><i>A magisterial sweep through 1500 years of Christian history with a groundbreaking focus on the missionary role of migrants in its spread.</i><i> </i></p><p>Human migration has long been identified as a driving force of historical change. Building on this understanding, Jehu Hanciles surveys the history of Christianity’s global expansion from its origins through 1500 CE to show how migration—more than official missionary activity or imperial designs—played a vital role in making Christianity the world’s largest religion. </p><p>Church history has tended to place a premium on political power and institutional forms, thus portraying Christianity as a religion disseminated through official representatives of church and state. But, as Hanciles illustrates, this “top-down perspective overlooks the multifarious array of social movements, cultural processes, ordinary experiences, and non-elite activities and decisions that contribute immensely to religious encounter and exchange.” </p><p>Hanciles’s socio-historical approach to understanding the growth of Christianity as a world religion disrupts the narrative of Western preeminence, while honoring and making sense of the diversity of religious expression that has characterized the world Christian movement for two millennia. In turning the focus of the story away from powerful empires and heroic missionaries, <i>Migration and the Making of Global Christianity </i>instead<i> </i>tells the more truthful story of how every Christian migrant is a vessel for the spread of the Christian faith in our deeply interconnected world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jehu J. Hanciles, Philip Jenkins
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Jehu J. Hanciles</B>&#160;is the D. W. and Ruth Brooks Associate Professor of World Christianity at Emory University. Originally from Sierra Leone, he is also the author of&#160;<I>Beyond Christendom: Globalization, African Migration, and the Transformation of the West</I>&#160;and&#160;<I>Euthanasia of a Mission: African Church Autonomy in a Colonial Context.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fb38e68a